<template>
  <div class="customer-success">
    <div class="header z-1">
      <div class="header__content">
        <a :href="linkHome">
          <img src="~@/assets/paguemenos.png" alt="Logo Pague Menos" height="62">
        </a>
      </div>
    </div>

    <div class="customer-success__icon">
      <img src="@/assets/icons/success-big.svg" alt="Sucesso icone" loading="lazy">
    </div>
    <section class="top">
      <h1 class="top__title">Parabéns! Sua compra foi realizada!</h1>
      <p class="top__subtitle">Você receberá no e-mail <b>{{ email }}</b> a confirmação da sua compra e o link de acesso para começar a utilizar o Saúde Protegida.</p>
    </section>
    <section>
       <NPS
        :name="name"
        :email="email"
        typePayment="creditCard"
      />
    </section>
    <section class="card__resume">
      <h3 class="card__resume__title">Resumo da compra</h3>
      <div class="card__resume__grid card__resume--bottom">
        <span class="grid__title">Valor mensal:</span>
        <span class="grid__value">{{ getPlanValue | formatValue }}</span>
      </div>
      <template v-if="haveDiscount">
        <div class="card__resume__grid">
          <span class="grid__title">Desconto de:</span>
          <span class="grid__value">- {{ getValuePromo }}</span>
        </div>
        <div class="section__hrLine"></div>
        <div class="card__resume__grid">
          <span class="grid__title">Total mensal:</span>
          <span class="grid__value">{{ payment.amount | formatValue }}</span>
        </div>
      </template>
    </section>
    <section class="card__payment">
      <div class="card__payment__title">
        <img src="@/assets/icons/card.svg" alt="Card icone" loading="lazy">
        <h1 class="title__style"> Pagamento </h1>
      </div>
      <div class="card__payment__value">
        <template>
          <i class="iconBrand" :class="[brandClass]"></i>
          <span class="value--bold value--padding_left">{{ payment.payment.cardBrand }}</span>
          <span class="value--normal">****{{ payment.payment.lastcardNumbers }}</span>
        </template>
      </div>
    </section>
    <section class="card__details" :class="{ 'card__details--open': show }">
      <div class="card__details__title">
        <img src="@/assets/icons/health.svg" alt="Saude icone" loading="lazy">
        <h1 class="title__style">{{ titlePlan }}</h1>
      </div>
      <div class="card__details__line" v-if="isMobile()"></div>
      <button class="card__details__button" @click.prevent="showDetails()">
        <div class="content">
          <img src="@/assets/icons/arrow-to-bottom.svg" alt="Sucesso icone" loading="lazy" class="icon__arrow">
          <span>Ver detalhes</span>
        </div>
      </button>
    </section>

    <transition-group name="fade">
      <section class="card__info" v-if="show && showListSequence[0]" key="1">
        <img src="@/assets/icons/icons-video-consultation.svg" alt="Telemedicina icone" loading="lazy">
        <h1 class="card__info__title">Telemedicina pronto atendimento</h1>
      </section>
      <section class="card__info" v-if="show && showListSequence[1] && (isPlus || isSpecial)" key="2">
        <img src="@/assets/icons/telemedicine.svg" alt="Telemedicina icone" loading="lazy">
        <h1 class="card__info__title">Telemedicina agendada por especialidades</h1>
      </section>
      <section class="card__info" v-if="show && showListSequence[2]" key="3">
        <img src="@/assets/icons/icons-medication.svg" alt="Medicamentos icone" loading="lazy">
        <h1 class="card__info__title">Até 80% de desconto em medicamentos</h1>
      </section>
      <section class="card__info" v-if="show && showListSequence[3] && isPlus" key="4">
        <img src="@/assets/icons/icons-medic.svg" alt="Consultas presenciais icone" loading="lazy">
        <h1 class="card__info__title">Até 80% de desconto em consultas presenciais</h1>
      </section>
      <section class="card__info" v-if="show && showListSequence[4] && isPlus" key="5">
        <img src="@/assets/icons/icons-laboratory.svg" alt="Exames laboratoriais icone" loading="lazy">
        <h1 class="card__info__title">Até 80% de desconto em exames laboratoriais</h1>
      </section>
    </transition-group>
  </div>
</template>

<script>
import { set } from 'vue'
import { mapActions } from 'vuex'
import dataLayer from '@/utils/data-layer'
import mobileDetector from '@/mixins/mobile-detector'
import NPS from '@/components/molecules/NPS.vue'

export default {
  name: 'CustomerSuccess',
  components: {
    NPS
  },
  filters: {
    formatValue (value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value)
    }
  },
  mixins: [mobileDetector],
  data () {
    return {
      show: false,
      showBackButton: true,
      showListSequence: [],
      descriptions: {
        instant: {
          title: 'Parabéns! Sua compra foi realizada!',
          warning: '',
          payment: 'Pagamento'
        }
      },
      payment: JSON.parse(window.sessionStorage.getItem('semprebem:payment')),
      checkout: JSON.parse(window.sessionStorage.getItem('semprebem:checkout'))
    }
  },
  mounted () {
    setTimeout(() => {
      dataLayer('saude-semprebem', 'saude-pagamento', 'click', '2-continuar')
    }, 5000)

    if (!this.payment) {
      this.$router.push({ name: 'checkout' })
    }
  },
  computed: {
    linkHome () {
      return process.env.VUE_APP_URL_HOME
    },
    name () {
      return this.checkout?.personalData?.name || ''
    },
    email () {
      return this.checkout?.personalData?.email || ''
    },
    confirmation () {
      return this.payment.isInstant
    },
    getPlanValue () {
      return this.payment.amount
    },
    getValuePromo () {
      return Number(
        this.checkout.plan.preco - this.payment.amount
      ).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    brandClass () {
      if (this.payment.payment.cardBrand) {
        return (
          [
            'amex',
            'aura',
            'diners',
            'discover',
            'elo',
            'hiper',
            'hipercard',
            'jcb',
            'master',
            'visa'
          ].find(v => v === this.payment.payment.cardBrand.toLowerCase()) ||
            'placeholder'
        )
      }
      return false
    },
    haveDiscount () {
      return this.checkout.plan.preco - this.payment.amount > 0
    },
    titlePlan () {
      return `${this.checkout.plan.name}`
    },
    isPlus () {
      return this.checkout.plan.category === 'PLUS'
    },
    isSpecial () {
      return this.checkout.plan.category === 'SPECIAL'
    }
  },
  beforeDestroy () {
    this.resetAllState()
    window.sessionStorage.removeItem('semprebem:health')
    window.sessionStorage.removeItem('semprebem:product')
    window.sessionStorage.removeItem('semprebem:checkout')
    window.sessionStorage.removeItem('semprebem:payment')
  },
  methods: {
    ...mapActions(['resetAllState']),
    showDetails () {
      this.show = !this.show

      if (this.show) {
        let items = [1, 3]
        if (this.isSpecial) items = [1, 2, 3]
        if (this.isPlus) items = [1, 2, 3, 4, 5]

        items.forEach((item, i) => {
          setTimeout(() => {
            set(this.showListSequence, item - 1, true)
          }, 300 * i)
        })
      } else {
        this.showListSequence = []
      }
    }
  }
}
</script>

  <style lang="scss" scoped>
  @import "@/assets/style/_variables";

  .header {
    background-color: #ffffff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
    height: 82px;
    position: absolute;
    width: 100%;
    z-index: 1;
    left: 0;
    top: 0;

    &__content {
      align-items: center;
      display: flex;
      justify-content: center;
      height: 100%;
      margin: 0 auto;
      max-width: 1313px;
      padding-left: 16px;
      width: 100%;

      @media screen and (min-width: 840px) and (max-width: 1366px) {
        padding-left: 80px;
      }
    }
  }

  .customer-success {
    display: grid;
    padding: 24px 16px 36px 16px;
    margin: 64px auto 0;

    @media screen and (min-width: 768px) {
      padding: 32px 24px 64px;
      max-width: 900px;
      margin: 64px auto 0;
    }

    &__icon {
      justify-self: center;
    }

    .top {
      &__title {
        font-family: "oscine", "Helvetica Neue", "Helvetica", "Roboto", "Arial",
          sans-serif;
        font-size: 24px;
        font-weight: bold;
        color: #444444;
        text-align: center;
        margin: 4px 0 16px 0;
      }
      &__subtitle {
        max-width: 752px;
        margin: 0 auto;
        line-height: 24px;
        font-family: Rubik;
        font-size: 16px;
        font-weight: normal;
        text-align: center;
        color: #595959;
      }
    }
  }

  .card__resume {
    border-radius: 8px;
    border: solid 1px rgba(189, 194, 198, 0.4);
    background: #ffffff;
    padding: 16px;
    margin-block: 32px 16px;

    @media screen and (min-width: 768px) {
      border-radius: 8px;
      padding: 32px 28px;
    }

    &__title {
      font-family: Oscine;
      font-size: 20px;
      font-weight: bold;
      color: #444444;
      padding-bottom: 18px;
    }

    &__grid {
      display: grid;
      grid-template-columns: 1fr max-content;

      .grid__title {
        font-family: Rubik;
        font-size: 14px;
        font-weight: normal;
        color: #444444;
        @media screen and (min-width: 768px) {
          font-size: 16px;
        }
      }
      .grid__value {
        font-family: Rubik;
        font-size: 16px;
        font-weight: 500;
        color: #444444;
      }
    }
    &--bottom {
      padding-bottom: 13px;
    }
  }

  .card__payment {
    display: grid;
    grid-template-columns: 1fr max-content;
    border-radius: 8px;
    border: solid 1px rgba(189, 194, 198, 0.4);
    background: #ffffff;
    padding: 16px;
    margin-bottom: 16px;

    @media screen and (min-width: 768px) {
      padding: 32px 28px;
    }

    &__title {
      display: none;
      align-items: center;
      @media screen and (min-width: 768px) {
        display: grid;
        grid-template-columns: max-content max-content;
        gap: 16px;
      }
      .title__style {
        font-family: Oscine;
        font-size: 18px;
        font-weight: bold;
        color: #444444;
      }

      img {
        width: 36px;
        height: 36px;
      }
    }
    &__value {
      display: grid;
      grid-template-columns: 1fr repeat(3, max-content);
      align-items: center;
      font-family: Rubik;
      font-size: 16px;
      color: #595959;
      place-self: center;
      .value--bold {
        font-weight: bold;
      }
      .value--weight {
        font-weight: 500;
        font-size: 16px;
      }
      .value--normal {
        font-weight: normal;
      }
      .value--padding_left {
        padding-left: 16px;
      }
      .iconBrand {
        display: block;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
        border: none;
        width: 48px;
        height: 48px;

        $brands: (
          amex,
          aura,
          diners,
          discover,
          elo,
          hiper,
          hipercard,
          jcb,
          master,
          placeholder,
          visa
        );

        @each $brand in $brands {
          &.#{$brand} {
            background-image: url("../../assets/flags/#{$brand}.png");
          }
        }
      }
    }
  }

  .card__details {
    display: grid;
    grid-template-columns: 1fr;
    border: solid 1px rgba(189, 194, 198, 0.4);
    border-radius: 8px;
    background: #ffffff;

    &--open {
      border-radius: 8px 8px 0 0;
      .icon__arrow {
        transform: rotate(180deg);
      }
    }
    .icon__arrow {
      transition: transform 0.3s ease-in-out;
    }

    @media screen and (min-width: 768px) {
      display: grid;
      grid-template-columns: 1fr max-content;
      padding: 32px 28px;
    }
    &__title {
      display: grid;
      grid-template-columns: max-content 1fr;
      gap: 16px;
      align-items: center;

      img {
        width: 36px;
        height: 36px;
      }

      @media screen and (max-width: 767px) {
        padding: 24px 16px;
      }
      .title__style {
        font-family: Oscine;
        font-size: 18px;
        font-weight: bold;
        color: #444444;
      }
    }
    &__line {
      @media screen and (max-width: 767px) {
        border-top: 1px solid #bdc2c6;
        opacity: 0.3;
      }
    }
    &__button {
      background: none;
      cursor: pointer;

      @media screen and (max-width: 767px) {
        padding: 10px 0 14px;
      }

      img {
        width: 24px;
        height: 24px;
      }

      .content {
        justify-content: center;
        align-items: center;
        display: flex;

        span {
          font-family: Oscine;
          font-size: 16px;
          font-weight: normal;
          color: #444444;
          padding-left: 8px;

          @media screen and (min-width: 768px) {
            font-weight: bold;
          }
        }
      }
    }
  }

  .card__info {
    display: grid;
    grid-template-columns: max-content 1fr;
    gap: 16px;
    align-items: center;
    border: solid 1px rgba(189, 194, 198, 0.4);
    background: #ffffff;
    padding: 16px;
    border-top: none;

    @media screen and (min-width: 768px) {
      padding: 32px 28px;
    }
    &__title {
      font-family: Oscine;
      font-size: 16px;
      font-weight: normal;
      color: #444444;
    }

    &:last-of-type {
      border-radius: 0 0 8px 8px;
    }
  }

  .section__hrLine {
    height: 1px;
    margin: 24px 0 16px;
    opacity: 0.3;
    background-color: #bdc2c6;
  }

  .button__back {
    padding-top: 32px;
    margin: 0 auto;
    &__btn {
      display: grid;
      grid-template-columns: max-content max-content;
      background: none;
      align-items: center;
      cursor: pointer;
    }
    &__text {
      font-family: Oscine;
      font-size: 16px;
      font-weight: bold;
      color: #595959;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease-in-out;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  </style>
